/** 盤點比對 anomalies 代碼 → 顯示文案。盤點量 0 ≠ NOT_COUNTED。 */
export const STOCKTAKE_ANOMALY_LABELS = {
  NOT_COUNTED: '未盤點',
  QUANTITY_MISMATCH: '數量不符',
  WAREHOUSE_MISMATCH: '倉別不符',
  STOCK_NOT_FOUND: '庫存不存在',
  MULTIPLE_COUNTED_WAREHOUSES: '多倉盤點',
  MULTIPLE_STOCKTAKES: '多次盤點',
};

export const STOCKTAKE_ANOMALY_FILTER_OPTIONS = Object.entries(STOCKTAKE_ANOMALY_LABELS)
  .map(([value, label]) => ({ value, label }));

export const STOCKTAKE_ABNORMAL_FILTER_OPTIONS = [
  { value: 'true', label: '是' },
  { value: 'false', label: '否' },
];

export function formatStocktakeAnomalyLabel(code) {
  if (code == null || code === '') {
    return '—';
  }
  return STOCKTAKE_ANOMALY_LABELS[code] || String(code);
}

export function resolveComparisonStockNo(row) {
  const safe = row ?? {};
  return safe.stockNo
    || safe.inventoryStock?.stockNo
    || '';
}

export function resolveWarehouseLabel(warehouse) {
  if (warehouse == null || typeof warehouse !== 'object') {
    return '—';
  }
  return warehouse.name || warehouse.code || '—';
}

/**
 * 比對列關聯盤點單：優先 stocktakeItems；相容舊 stocktakeIds；否則本列單筆 fallback。
 * @returns {{ id: string, no: string }[]}
 */
export function resolveComparisonStocktakeItems(row) {
  const safe = row ?? {};
  const items = safe.stocktakeItems ?? safe.stocktake_items;

  if (Array.isArray(items) && items.length > 0) {
    return items
      .map((item) => {
        if (item == null || typeof item !== 'object') {
          return null;
        }
        const id = item.stocktakeId ?? item.stocktake_id ?? '';
        if (!id) {
          return null;
        }
        const no = item.stocktakeNo ?? item.stocktake_no ?? '';
        return { id: String(id), no: no ? String(no) : '' };
      })
      .filter(Boolean);
  }

  const legacyIds = safe.stocktakeIds ?? safe.stocktake_ids;
  if (Array.isArray(legacyIds) && legacyIds.length > 0) {
    return legacyIds
      .filter(Boolean)
      .map((id) => ({ id: String(id), no: String(id) }));
  }

  const rowId = safe.stocktakeId ?? safe.stocktake_id ?? '';
  if (rowId) {
    const rowNo = safe.stocktakeNo ?? safe.stocktake_no ?? '';
    return [{ id: String(rowId), no: rowNo ? String(rowNo) : '' }];
  }

  return [];
}

export function isComparisonRowAbnormal(row) {
  const safe = row ?? {};
  if (safe.abnormal === true) {
    return true;
  }
  const anomalies = safe.anomalies;
  return Array.isArray(anomalies) && anomalies.length > 0;
}
